import React, { useState, useEffect } from 'react';
import { AppProvider, useApp } from './context/AppContext';
import LoginPage from './pages/LoginPage';
import BeneficiaryForm from './pages/BeneficiaryForm';
import PMDashboard from './pages/PMDashboard';
import AccountantDashboard from './pages/AccountantDashboard';
import MDDashboard from './pages/MDDashboard';

function LoadingScreen() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #1C1B2E 0%, #2d2b48 50%, #1C1B2E 100%)' }}>
      <div style={{ fontSize: 24, fontWeight: 700, color: '#fff', marginBottom: 20 }}>WM Payments</div>
      <div style={{ display: 'flex', gap: 8 }}>{[0,1,2].map(i => <div key={i} style={{ width: 10, height: 10, borderRadius: '50%', background: '#534AB7', animation: 'pulse 1.2s ease-in-out ' + (i*0.2) + 's infinite' }} />)}</div>
      <style>{`@keyframes pulse { 0%,80%,100%{opacity:0.2;transform:scale(0.8)} 40%{opacity:1;transform:scale(1)} }`}</style>
    </div>
  );
}

function AppRouter() {
  const { currentUser, loading } = useApp();
  const [isBeneficiaryView, setIsBeneficiaryView] = useState(false);
  useEffect(() => {
    const checkHash = () => setIsBeneficiaryView(window.location.hash === '#beneficiary');
    checkHash();
    window.addEventListener('hashchange', checkHash);
    return () => window.removeEventListener('hashchange', checkHash);
  }, []);
  if (loading) return <LoadingScreen />;
  if (isBeneficiaryView) return <BeneficiaryForm onBack={() => { window.location.hash = ''; setIsBeneficiaryView(false); }} />;
  if (!currentUser) return <LoginPage />;
  if (currentUser.role === 'pm') return <PMDashboard />;
  if (currentUser.role === 'accountant') return <AccountantDashboard />;
  if (currentUser.role === 'md') return <MDDashboard />;
  return <div style={{ padding: 40, textAlign: 'center' }}>Unknown role.</div>;
}

export default function App() {
  return <AppProvider><AppRouter /></AppProvider>;
}
